<div class="main-content table-page perfiles-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Perfiles</h1>
        <p>Administre los roles y permisos del sistema de manera centralizada.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="altaperfil()">
        <i class="material-icons">add</i>
        <span>Alta de Perfil</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaPerfil.length > 0; else perfilesEmptyState">
          <thead>
            <tr>
              <th>Nombre del Perfil</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let perfil of listaPerfil">
              <td class="table-page__name">{{ perfil.nombre || "Sin nombre" }}</td>
              <td class="table-page__description">{{ getSiteDescription(perfil) }}</td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(perfil)">
                  {{ getStatusLabel(perfil) }}
                </span>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="modificaperfil(perfil)">
                  <i class="material-icons">edit</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #perfilesEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else perfilesLoading">
            <i class="material-icons">supervisor_account</i>
            <strong>No se encontraron perfiles</strong>
            <span>Intenta nuevamente o crea un nuevo perfil desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #perfilesLoading>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando perfiles...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="totalRegistros > 0">
        <div class="table-page__meta">
          <span>Mostrando {{ getRangeEnd() }} de {{ totalRegistros }} perfiles</span>

          <label class="table-page__page-size">
            <span>Registros:</span>
            <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else perfilesPagerEllipsis" type="button" class="table-page__pager-page"
              [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #perfilesPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()"
            [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()"
            [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
